var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextLink as BaseTextLink, Button, clsx, } from '@a-type/ui';
import { Link as RouterLink, } from '@tanstack/react-router';
import { forwardRef } from 'react';
import cls from './Link.module.css';
export { BaseTextLink };
export const Link = forwardRef(function Link(_a, ref) {
    var { className, newTab } = _a, props = __rest(_a, ["className", "newTab"]);
    return (_jsx(RouterLink, Object.assign({ ref: ref, className: className }, getNewTabProps(newTab), props)));
});
function getNewTabProps(newTab) {
    if (newTab) {
        return {
            target: '_blank',
            rel: 'noopener noreferrer',
        };
    }
    return {};
}
export const LinkButton = forwardRef(function LinkButton(_a, ref) {
    var { className, color, size, emphasis, newTab } = _a, props = __rest(_a, ["className", "color", "size", "emphasis", "newTab"]);
    return (_jsx(Button, { render: _jsx(Link, Object.assign({ ref: ref, className: clsx(cls.linkButton, className) }, getNewTabProps(newTab), props)), color: color, size: size, emphasis: emphasis, nativeButton: false }));
});
export const TextLink = forwardRef(function TextLink(_a, ref) {
    var { className, newTab } = _a, props = __rest(_a, ["className", "newTab"]);
    return (_jsx(BaseTextLink, { render: _jsx(Link, Object.assign({ ref: ref }, getNewTabProps(newTab), { className: clsx(cls.textLink, className) }, props)) }));
});
//# sourceMappingURL=Link.js.map